'use client'

import React, { useState } from 'react'
import { signIn } from 'next-auth/react'
import { FcGoogle } from "react-icons/fc";
import { Logo } from '@fsg/svg'
import { LightProgressLoader } from './LightProgressLoader'
import { Button } from './Button'
import { ButtonV2 } from './ButtonV2';

export function Login() {
  const [loading, setLoading] = useState(false)

  const onSignIn = () => {
    setLoading(true)
    signIn('fsg')
  }

  return (
    <div className="grid h-screen md:grid-cols-2">
      <div className="hidden bg-blue-600 p-8 md:flex md:flex-col md:justify-between">
        <Logo className="w-16" color='#fff'/>
        <div className="mb-12 mr-4">
          <blockquote className="text-2xl font-light text-white mr-lg">
            "An unprofitable corporation does nobody good. Not society, Not its employees, Not itself; therefore it has the right and the responsibility to make a profit."
          </blockquote>
          <p className="mt-sm text-white/80">Bill Graham</p>
        </div>
      </div>

      {/* Right Section */}
      <div className="bg-white flex flex-col items-center justify-center p-8">
        <Logo className="w-16 md:hidden"/>
        <div className="w-full max-w-md">
      
            <h1 className="text-center text-2xl font-semibold">Login</h1>
          <p className="text-center text-gray-600 pb-xs">
            Login now with your FSG email address
          </p>
                  
         
          <div className='border border-transparent border-b-gray-400 pb-xl'>
            {loading ? (
            <div className="h-14">
              <LightProgressLoader />
            </div>
          ) : (
<ButtonV2 variant='secondary' size='lg' onClick={onSignIn} loading={loading} className='w-full justify-center'>
  <span className="flex items-center justify-center gap-2">
                <FcGoogle />
                Google
              </span>
</ButtonV2>
          )}
          </div>
          <div className="mt-8 text-[10px] text-justify text-gray-darker">
            <p>
              <strong className='text-gray-darkest'>THIS IS A PRIVATE COMPUTER SYSTEM. </strong>
              This computer system, including all related equipment, and network devices (specifically including Internet access), is provided only for authorized use.
              <strong className='text-gray-darkest'> Users (authorized or unauthorized) have no explicit or implicit expectation of privacy.</strong>
            </p>
            <p className='mt-2'>
              Any or all uses of this system and all files on this system may be intercepted, monitored, recorded, copied, audited, inspected, and disclosed to authorized site and law enforcement personnel, as well as authorized officials of other agencies, both domestic and foreign.
              <strong className='text-gray-darkest'> By using this system, the user consents to such interception, monitoring, recording, copying, auditing, inspection, and disclosure at the discretion of authorized FSG site personnel.</strong>
            </p>
            <p className="mt-2">
              Unauthorized or improper use of this system may result in administrative disciplinary action and civil and criminal penalties. By continuing to use this system, you indicate your awareness of and consent to these terms and conditions of use.
              <strong className='text-gray-darkest'> LOG OFF IMMEDIATELY if you do not agree to the conditions stated in this warning.</strong>
            </p>
            <p className='mt-2'>
              If you are not authorized to use this system, you are hereby informed and advised to immediately notify FSG at the designated contact information below.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}